const brightcoveRequestCache: Record<string, Promise<unknown>> = {}

export function fetchBrightcoveData<T>(
  accountId: string,
  policyKey: string,
  resourceUrl: string
): Promise<T> {
  const cacheKey = `${accountId}|${policyKey}|${resourceUrl}`

  const cachedRequest = brightcoveRequestCache[cacheKey]
  if (cachedRequest !== undefined) {
    return cachedRequest as Promise<T>
  }

  const request = fetch(
    `https://edge.api.brightcove.com/playback/v1/accounts/${accountId}/${resourceUrl}`,
    {
      headers: { accept: `application/json;pk=${policyKey}` },
      method: 'GET'
    }
  )
    .then(response => {
      if (!response.ok) {
        throw new Error(`Brightcove request failed: ${response.status}`)
      }
      return response.json()
    })
    .catch(error => {
      delete brightcoveRequestCache[cacheKey]
      throw error
    })

  brightcoveRequestCache[cacheKey] = request as Promise<unknown>
  return request as Promise<T>
}

export function getVideoResourceUrl(
  videoId?: string,
  playlistId?: string
): string {
  return videoId ? `videos/${videoId}` : `playlists/${playlistId}`
}
